import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import type { TermAndCondition } from '@core/models/app.model';

import { OfferingTermsAndConditionsListComponent } from '../../shared/offering-terms-and-conditions-list/offering-terms-and-conditions-list.component';

@Component({
  selector: 'ume-subscribe-offering-dialog',
  templateUrl: './subscribe-offering-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCheckbox,
    FormsModule,
    OfferingTermsAndConditionsListComponent,
  ],
})
export class SubscribeOfferingDialogComponent {
  public data: {
    title: string;
    terms: TermAndCondition[];
  } = inject(MAT_DIALOG_DATA);

  public terms: TermAndCondition[];
  public agreeTerms = false;

  constructor() {
    this.terms = this.data.terms;
  }
}
